export default "__VITE_ASSET__DnuXlTO___"